<template style="height: 100%">
    <div class="ra mrt20 leftborder">
        <!--头部-->
        <div class="ml5">
            <span style="font-size: 16px;font-weight: bold">|</span>
            <span class="mrl20"  style="font-size: 16px; font-weight: bold">设备管理</span>
        </div>
        <div class="flex mrt20 ml5">
            <!--<template>
                <el-date-picker
                        size="mini"
                        v-model="begin_time"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        style="width: 15%"
                        placeholder="选择日期">
                </el-date-picker>
                <span class=" middle" style="font-size: 14px">-</span>
                <el-date-picker
                        size="mini"
                        v-model="end_time"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        style="width: 15%"
                        placeholder="选择日期">
                </el-date-picker>
            </template>-->
            <template>
                <el-input  style="width: 15%" v-model="explain" placeholder="请输入" clearable size="mini"></el-input>
                <el-button class="mrl20" type="primary" @click="searchData"  :class="baseerp+'btn'" size="mini">查询</el-button>
            </template>
        </div>
        <!--表单部分-->
        <div  class="tableHeight ml5">
            <el-table
                    ref="table"
                    class="mrt10"
                    size="mini"
                    :data="tableData"
                    :height="tableHeight"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    @row-click="rowClick"
                    :highlight-current-row="highlightCurrentRow"
                    :row-class-name="tableRowClassName">
                <el-table-column
                        prop="vc_code"
                        label="设备编码">
                </el-table-column>
                <el-table-column
                        prop="vc_name"
                        label="设备名称">
                </el-table-column>
                <el-table-column
                        prop="dt_createtime"
                        label="时间">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="150">
                    <template slot-scope="scope">
                        <el-button @click="editData(scope.row)" style="border: none" >{{scope.row.i_state==1?"停用":"启用"}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagetxt">
                <span>共{{tableTotal}}条，每页显示{{pageSize}}条</span>
            </div>
            <el-pagination
                    class="fr page"
                    background
                    layout="prev, pager, next"
                    @current-change="pageCurrentChange"
                    :current-page.sync="currentPage"
                    :total="tableTotal"
                    :page-size="pageSize">
            </el-pagination>
        </div>
        <!--dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                    width="600px"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
                <edit :application="application" @close="cancelDialog" @getDeviceList="getDeviceList"></edit>
            </el-dialog>
        </div>

        <!--分页-->
        <!--<div>

        </div>-->
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import * as API from  "../api";
    import axios from "axios";
    import edit from "./edit";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "maintainsche",
        components:{edit},
        props:{

        },
        mounted(){
            this.baseerp=baseerp;
            ///调用列表接口
            this.getDeviceList();
            // console.log(this.formvalue,"this.formvalue");
            this.$nextTick(function () {
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 280;

                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.tableHeight = window.innerHeight - self.$refs.table.$el.clientTop - 280
                }
                // console.log(window.innerHeight,"H")
            })
            //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
            //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度　

        },

        data(){
            return{
                groupid:"",
                showscheduleId:"",
                explain:"",
                /***********************************/
                i_id:"",
                i_type:"",
                apptitle:"",
                bfapp:[],
                dialogVisible:false,
                title:"",
                begin_time:"",
                end_time:"",
                tableData:[],
                pageSize:12,
                currentPage:1,
                tableTotal:0,
                vcName:"",
                application:{},
                highlightCurrentRow:false,
                disabled:false,
                baseerp:"",
                mid:0,
                tableHeight:0,
            }
        },
        watch:{

        },

        methods:{
            ...mapActions(["getCurrentMenuId"]),

            //当前行color==3 整行灰掉
            tableRowClassName({row,rowIndex}){
                //console.log(row.id,"id");
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.color == 1) {

                    return 'danger-row';
                }
            },

            //拿到当前行数据
            rowClick(row){
                this.highlightCurrentRow=true;
                //console.log(row,"row");
             ///   this.application.i_pid=row.i_pid;
                // console.log(this.application,"this.application",this.application.i_pid)
            },

            //关闭dialog
            cancelDialog(val){
                //console.log(val,"val,,,,,,");
                //this.application.i_pid="";
                this.dialogVisible=false;
                //  console.log(this.application.i_pid,"cancelDialog");
                this.highlightCurrentRow=false;
                //    this.getArrangementList(val);
            },

            //点击编辑
            editData(row){
                //console.log(row,"row");
                if (row.i_state==0){
                    this.title="启用"
                }else{
                    this.title="停用"
                }
                this.dialogVisible=true;
                this.application={
                    i_id:row.i_id,
                    value:row,
                    currentPage:this.currentPage,
                    title:this.title,
                };
                //console.log(this.application,"editData");
            },



            //点击查询
            searchData(){
                //console.log(this.explain,this.begin_time,this.end_time,"searchData");
                ///调用列表接口
                this.getDeviceList();
            },

            //列表接口
            //getDeviceList
            async getDeviceList(pageSize){
                if(pageSize!=undefined) {
                    // console.log(pageSize,"pageSize");
                    this.currentPage=pageSize;
                }
                let param = {
                    vc_name:this.explain,
                    i_pageNum:this.currentPage,
                    i_pageSize:12,
                };
                let res = await API.getDeviceList(param);
                if (res.code == 1) {
                    this.tableData=res.list;
                    this.tableTotal=res.total;
                    //console.log(this.tableData,this.tableTotal,"this.tableData");
                    //this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //删除
            async delArrangement(){
                this.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( async () => {
                    let param = {
                        i_id:this.showId,
                    };
                    let res = await API.delArrangement(param);
                    if (res.code == 1) {
                        this.$message.success(res.message);
                        //console.log(this.currentPage,"当前页");
                        this.getArrangementList(this.currentPage);
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    }else{
                        this.$message.error(res.message);
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },

            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                ///调用列表接口
                this.getDeviceList();
            },
        },
    }

</script>

<style lang="scss" scoped>

    .pagetxt{
        display: inline-block;
        padding: 6px 6px;
        font-size: 14px;
    }

    .ml5{
        margin-left:5px;
    }

    .leftborder{
        border-left: 1px solid #eee;
    }

    .ra{
        height: 100%;
    }

    .flex_search{
        justify-content: space-between;
    }

    .flex{
        justify-content: left;
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .cl{
        clear: both;
    }
    .mrt10{
        margin-top: 6px;
    }
    .mrt20{
        margin-top: 10px;
    }
    .mrl20{
        margin-left: 10px;
    }
    .mrb40{
        margin-bottom: 60px;
    }
    /*.page{
        padding: 25px 15px;
    }*/
    .middle{
        line-height: 30px;
    }
    /*.tableHeight{
        min-height: 460px;
        height: 100%;
    }*/
    /deep/{

        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }



        .el-tabs--border-card > .el-tabs__content{
            height: calc(100% - 60px);
            overflow-y: auto;

        }
    }

    .cor37{
        color:#c37f00;
    }

    /deep/{
        .danger-row{
            color: #999 !important ;
        }
    }



</style>